import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Select from 'react-select';
import { formatNumber, Site } from '@debbie/common/dist/index.js';
import { caseFilterhash, } from '@debbie/common/dist/insights/index.js';
import { h, c } from '@debbie/cortex/dist/index.js';
import { selectCaseFilterCount } from '@debbie/cortex/dist/insights/selectors.js';
import THEME from '../../theme.js';
import Button from '../Button.js';
import CreditorSelector from '../CreditorSelector.js';
import Modal from '../Modal.js';
import AdvancedFilter from './AdvancedFilter.js';
import CaseFilterBadges from './CaseFilterBadges.js';
import CaseFilterQueue from './CaseFilterQueue.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups/index.js';
const Filter = (props) => {
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const caseFilterCount = useSelector(selectCaseFilterCount);
    const tenant = useSelector(selectTenant);
    const isCaseFilterCountNotLoaded = useSelector((s) => h.isNotLoaded(s.caseFilterCount[caseFilterhash(s.caseFilter)]));
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const caseFilter = useSelector((s) => s.caseFilter);
    const toggleFilterModal = () => setFilterModalOpen(!filterModalOpen);
    useEffect(() => {
        if (isCaseFilterCountNotLoaded)
            c.insights.getCaseFilterCount(caseFilter);
    }, [caseFilter]);
    return (React.createElement(StyledFilter, null,
        React.createElement("div", null,
            tenant?.type === TenantType.AccountsReceivable ? (React.createElement(CaseGroupSelector, null)) : (React.createElement(CreditorSelector, { style: {
                    width: '100%',
                    marginRight: '5px',
                }, onChange: props.onChange })),
            site == Site.Caseworker && (React.createElement(Button, { theme: "secondary", size: "small", onClick: toggleFilterModal }, lang.caseFilter.moreFilters)),
            filterModalOpen && (React.createElement(Modal, { onToggle: toggleFilterModal, header: lang.caseFilter.advancedFilters },
                React.createElement(AdvancedFilter, null)))),
        React.createElement("p", null,
            React.createElement("b", null, caseFilterCount
                ? formatNumber(caseFilterCount * 100).slice(0, -3)
                : '-'),
            ' ',
            lang.caseFilter.casesSelected,
            " ",
            React.createElement(CaseFilterQueue, null),
            " ",
            React.createElement(CaseFilterBadges, null))));
};
export default Filter;
const StyledFilter = styled.div `
  & > div {
    margin-bottom: ${THEME.GRID_SPACING}px;
    display: flex;
    justify-content: space-between;
  }

  & > p {
    margin: -1em 0 0 0;
    font-size: 0.8em;
  }
`;
const CaseGroupSelector = () => {
    const lang = useSelector((s) => s.lang);
    const caseFilter = useSelector((s) => s.caseFilter);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    return (React.createElement("div", { style: {
            width: '100%',
            marginRight: '5px',
        } },
        React.createElement(Select, { value: (caseFilter.caseGroups || []).map((caseGroupId) => {
                const caseGroup = caseGroups && caseGroups.find((cG) => cG.id === caseGroupId);
                return {
                    label: (caseGroup && caseGroup.label) || caseGroupId,
                    value: caseGroupId,
                };
            }), isMulti: true, placeholder: lang.caseFilter.selectCaseGroup, classNamePrefix: "select", options: (caseGroups || []).map((caseGroup) => ({
                label: caseGroup.label,
                value: caseGroup.id,
            })), onChange: async (val) => {
                const selected = val ? val.map((v) => v.value) : [];
                c.insights.updateFilter({
                    caseGroups: selected,
                });
            } })));
};
//# sourceMappingURL=Filter.js.map